export default __webpack_public_path__ + "static/media/BOOST.806320ea.svg";